import {RefObject} from "react";

export const scrollToTop = (ref: RefObject<HTMLElement> | null, barOffset: number = 0) => {
    //ref?.current?.scrollIntoView({behavior: 'smooth', block: 'start'})
    if (ref !== null && ref.current !== null) {
        window.scrollTo({top: ref.current.offsetTop - barOffset, behavior: 'smooth'});
    }
}